import { useContextState } from "../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        items: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 1,
            minHeight: '40px',
            maxHeight: '45vh',
            overflowY: 'auto',
            marginBottom: 2
        },
        item: {
            padding: '6px 12px',
            backgroundColor: colors.color39,
            color: colors.color10,
            borderRadius: 6,
            display: 'flex',
            alignItems: 'center',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            '& .MuiSvgIcon-root': {
                color: colors.color10,
            },
        },
        delete: {
            '&.MuiIconButton-root': {
                padding: '0px 0px 0px 4px'
            }
        },
        secondSubtitle: {
            color: colors.backgroundDark,
            fontWeight: 'bold',
            marginBottom: 2
        },
    }
}

export { useStyles }
